/* eslint-disable react/jsx-pascal-case */
import {
  Col,
  DatePicker,
  ConfigProvider,
  Form,
  Input,
  Row,
  Button,
  Select,
  Card,
  Switch,
  TreeSelect
} from "antd";
import dayjs from "dayjs";
import React, { useEffect, useState, useRef } from "react";
// import Label_language from '../../language'
import UploadImg from "../../utility/UploadImg";
// import { useNewsType } from "../controller/NewsTypeController";
// import { useNewsWeightType } from "../../news_weight_type/controller/NewsWeightTypeController";
import JoditEditor from "jodit-react";
import axios from "axios";
const { ConfigContext } = ConfigProvider;

const ArticleManagementForm = ({
  propsForm = null,
  propsValue = null,
  formReloadCount = 0,
  onFormFinish = () => { },
}) => {
  const [form] = Form.useForm();
  const [checkStrictly, setCheckStrictly] = useState(0);
  const [internalLink, setInternalLink] = useState([]);
  const [blogFieldId, setBlogFieldId] = useState();
  const [files, setFiles] = useState([]);
  const [content, setContent] = useState("");

  const onImagesChange = (
    // fieldName,
    // subFieldName,
    name,
    changeValue,
    checkStrictly
  ) => {
    // let { items } = propsForm.getFieldsValue("blog_type_classify_structure_type_blog_data");
    // if (items) {

    //     items[fieldName].frontend_column_frontend_component_blog_type_blog_data[
    //       subFieldName
    //     ].blog_type_classify_structure_type_blog_data = changeValue;
    //   } else {
    //     let frontend_column_frontend_component_blog_type_blog_data_temp = {
    //       blog_type_blog_id: null,
    //       blog_id: null,
    //       title: null,
    //       content: null,
    //       annoucement_time: "2023-09-28T18:50:27.967904+08:00",
    //       top: null,
    //       top_edit_time: null,
    //       blog_index: null,
    //       more_content: null,
    //       show: null,
    //       external_link: null,
    //       youtube_iframe: null,
    //       youtube_thumbnail: null,
    //       property_json: null,
    //       extermal_link_check: null,
    //       blog_type_classify_structure_type_blog_data: changeValue,
    //     };
    //     items[fieldName].frontend_column_frontend_component_blog_type_blog_data[
    //       subFieldName
    //     ] = frontend_column_frontend_component_blog_type_blog_data_temp;
    //   }
    // }
    setCheckStrictly((pre) => pre + 1);
    const classify_structure_type_blog_data = propsForm.getFieldValue("classify_structure_type_blog_data");
    console.log(changeValue);
    let classify_structure_type_id = 0;
    classify_structure_type_blog_data.forEach(item => {
      classify_structure_type_id = item.classify_structure_type_id
    });
    propsForm.setFieldValue("blog_type_classify_structure_type_blog_data", changeValue.map(item=>{
      return {
        ...item,
        classify_structure_type_id
      }
    }));
  };
  const getExtermalLinkCheck = (field_name, subField_name) => {
    let temp = [];
    if (propsForm) {
      temp = propsForm.getFieldValue([
        "items",
        field_name,
        "frontend_column_frontend_component_blog_type_blog_data",
        subField_name,
        "extermal_link_check",
      ]);
    } else {
      temp = form.getFieldValue([
        "items",
        field_name,
        "frontend_column_frontend_component_blog_type_blog_data",
        subField_name,
        "extermal_link_check",
      ]);
    }
    return temp;
  };

  const setFormValuesOtherThings = (formValues) => {
    //做一些你可能會用到其他component的資料整理
    let newFormValues = {
      ...formValues,
      total: formValues?.comments * formValues?.number || 0,
    };
    if (propsForm) {
      propsForm.setFieldsValue(newFormValues);
    } else {
      form.setFieldsValue(newFormValues);
    }
  };
  const onChangeFileValue = (values) => {
    let file = values?.file ?? [];
    setFiles(file);
  };
  const setDataInitialization = (formValues) => {
    //做一些你可能會用到其他component的資料整理
    let newFormValues = {
      ...formValues,
      extermal_link_check: formValues.extermal_link_check === 1,
      total: formValues?.comments * formValues?.number || 0,
    };
    if (propsForm) {
      propsForm.setFieldsValue(newFormValues);
    } else {
      form.setFieldsValue(newFormValues);
    }
    setCheckStrictly((pre) => pre + 1);
    //   //拿個下拉選單等等的資訊
    //   getNewsTypeOption();
    //   getNewsWeightTypeOption();
  };
  const onFinish = (values) => {
    // let news_time = dayjs(values?.news_time).format("YYYY-MM-DD HH:mm:ss")
    // let announce_time_end = dayjs(values?.announce_time_end).format("YYYY-MM-DD HH:mm:ss")
    console.log({ values })
    onFormFinish({
      ...values,
      extermal_link_check: values.extermal_link_check ? 1 : 0
      // news_time,
      // announce_time_end
    });
  };
  const onValuesChange = () => {
    let formValues = null;
    if (propsForm) {
      formValues = propsForm.getFieldsValue();
    } else {
      formValues = form.getFieldsValue();
    }
    console.log(formValues)
    setFormValuesOtherThings(formValues);
  };
  const onContentChange = (content) => {
    setContent(content);
    if (propsForm) {
      propsForm.setFieldValue("more_content", content);
    } else {
      form.setFieldValue("more_content", content);
    }
  };
  const getFileListValue = (field_name, subField_name) => {
    let temp = [];
    if (propsForm) {
      temp = propsForm.getFieldValue("blog_type_classify_structure_type_blog_data");
    } else {
      temp = form.getFieldValue(
        "blog_type_classify_structure_type_blog_data");
    }
    return temp;
  };
  const disabledDate = (current) => {
    // Can not select days before today and today
    return current && current < dayjs().subtract(1, "day").endOf("day");
  };
  const range = (start, end) => {
    const result = [];
    for (let i = start; i < end; i++) {
      result.push(i);
    }
    return result;
  };

  const disabledDateTime = (current) => ({
    disabledHours: () => {
      let hour = dayjs().format("HH");
      let todayDate = dayjs().format("YYYY-MM-DD");
      let currentDate = dayjs(current).format("YYYY-MM-DD");
      if (todayDate === currentDate) {
        return range(0, 24).splice(0, parseInt(hour));
      } else {
        return range(0, 24).splice(0, 0);
      }
    },
    disabledMinutes: () => {
      let minutes = dayjs().format("mm");
      let hour = dayjs().format("HH");
      let todayDate = dayjs().format("YYYY-MM-DD");
      let currentDate = dayjs(current).format("YYYY-MM-DD");
      let currentHour = dayjs(current).format("HH");
      console.log({ minutes });
      if (todayDate === currentDate && currentHour === hour) {
        return range(0, 60).splice(0, parseInt(minutes) + 5);
      } else {
        return range(0, 0);
      }
    },
    disabledSeconds: () => {
      return range(0, 0);
    },
  });
  useEffect(() => {
    // setDataInitialization();
  }, []);
  useEffect(() => {
    let formValues = null;
    if (propsForm) {
      formValues = propsForm.getFieldsValue();
    } else {
      formValues = form.getFieldsValue();
    }
    setDataInitialization(formValues)
    onChangeFileValue(formValues);
    onContentChange(formValues?.more_content ?? "");
  }, [formReloadCount]);

  useEffect(() => {
    setContent(
      propsForm.getFieldValue("more_content")
    );
  }, [propsForm]);

  useEffect(() => {
    axios.get('/dynamicWebsite/frontend/permission', {
      params: {
        classify_structure_id: 5,
        classify_structure_type_id: 0,

      }
    })
      .then(response => {
        setInternalLink(response?.data['data'].map(map_item => ({
          title: map_item.name,
          value: `/officialweb/frontend/` + map_item.name,
          children: map_item.children.map(map_item => ({
            title: map_item.name,
            value: `/officialweb/frontend/` + map_item.name,
            children: map_item.children
          }))
        })))
        // setMenuItem(response?.data['data'])
      })
      .catch((error) => {
      })
      .finally(() => {
      })
  }, [])

  return (
    <Row>
      <Col span={24}>
        <Form
          labelCol={{ span: 6 }}
          wrapperCol={{ span: 18 }}
          layout="horizontal"
          form={propsForm ? propsForm : form}
          onValuesChange={onValuesChange}
          onFinish={onFinish}
          autoComplete="off"
        >
          {/* <Row gutter={[8, 8]} justify={"space-between"}>
            <Col span={24}> */}
          <Form.Item
            hidden={true}
            name={"blog_id"}

          >
            <Input>
            </Input>
          </Form.Item>
          <Form.Item>
            <Form.Item
              label="文章標題"
              name={"title"}
              rules={[
                {
                  required: true,
                  message: `此為必填項目`,
                },
              ]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              label="貼文內容"
              name={"content"}
              rules={[
                {
                  required: true,
                  message: `此為必填項目`,
                },
              ]}
            >
              <Input.TextArea />
            </Form.Item>
            <Form.Item
              label={"連結設定"}
              name={"extermal_link_check"}
              valuePropName="checked"
            >
              <Switch
                checkedChildren="外部連結"
                unCheckedChildren="內部連結"
                onChange={() => {
                  setCheckStrictly(
                    (pre) => pre + 1
                  );
                }}
              />
            </Form.Item>

            <Form.Item
              label={"連結"}
              name={
                "external_link"}
            // rules={[
            //     {
            //         required: true,
            //         message: `此為必填項目`
            //     },
            // ]}
            >
              {console.log(Form.useWatch("extermal_link_check", (!!propsForm ? propsForm : form)))}
              {Form.useWatch("extermal_link_check", (!!propsForm ? propsForm : form))
                ? (
                  <Input />
                ) : (
                  <TreeSelect
                    treeData={internalLink}
                    // defaultValue={departmentId}
                    showSearch
                    style={{
                      width: "100%",
                    }}
                    // value={internalLink}
                    dropdownStyle={{
                      maxHeight: 400,
                      overflow: "auto",
                    }}
                    placeholder="選擇頁面"
                    allowClear
                    treeDefaultExpandAll
                    treeNodeFilterProp={"title"}
                    onChange={(e) => {
                      // setDepartmentId(e)
                    }}
                    multiple={false}
                  // treeData={departmentData}
                  />
                )}
            </Form.Item>

            <Form.Item
              name={
                "classify_structure_type_blog_data"
              }
              noStyle
              initialValue={[]}
              hidden
            >
              <Input />
            </Form.Item>
            <Form.Item label="上傳圖片">
              <Form.Item
                name={
                  "blog_type_classify_structure_type_blog_data"
                }
                valuePropName="fileList"
                noStyle
                initialValue={[]}
              >
                <UploadImg
                  // api=''
                  defaultValue={getFileListValue(
                    checkStrictly
                  )}
                  onImagesChange={(value) => {
                    onImagesChange("blog_type_classify_structure_type_blog_data", value, checkStrictly);
                  }}
                />
              </Form.Item>
            </Form.Item>
            <Form.Item
              label={"Youtube連結"}
              name={"youtube_iframe"}
              rules={[
                {
                  message: "請輸入",
                },
              ]}
            >
              <Input.TextArea></Input.TextArea>
            </Form.Item>
            <Form.Item
              label={"詳細內容"}
              name={"more_content"}
              rules={[
                {
                  message: "請輸入",
                },
              ]}
              hidden={true}
            >
              <Input.TextArea></Input.TextArea>
            </Form.Item>
            <Form.Item label={"詳細內容"}>
              <Editor
                key={formReloadCount}
                propsForm={
                  !!propsForm ? propsForm : form
                }
                propsValue={(!!propsForm ? propsForm : form).getFieldsValue()}
                name="more_content"
              // field_name={field.name}
              // subField_name={subField.name}
              // field={[
              //   "items",
              //   field.name,
              //   "frontend_column_frontend_component_blog_type_blog_data",
              //   subField.name,
              //   "more_content",
              // ]}
              />
            </Form.Item>
          </Form.Item>
          {/* </Col>
          </Row> */}
        </Form >
      </Col >
    </Row >
  );
};

export default ArticleManagementForm;

const Editor = ({
  propsForm = null,
  propsValue = null,
  name = "more_content"
  // field_name = null,
  // subField_name = null,
  // field = [],
}) => {
  const [form] = Form.useForm();
  const [content, setContent] = useState("");
  const editor = useRef(null);
  const config = {
    // readonly: false, // all options from https://xdsoft.net/jodit/doc/
    // uploader: {
    //     insertImageAsBase64URI: true,
    //     // url: `${axios.defaults.baseURL}/api/literacy/admin/editor/file`
    // },
    // language: 'zh_tw'
    allowResizeTags: false,
    imageDefaultWidth: "100%",
    language: "zh_tw",
    i18n: {
      zh_tw: {
        Default: "預設",
        "Copyright © XDSoft.net - Chupurnov Valeriy. All rights reserved.":
          "Copyright © XDSoft.net - Chupurnov Valeriy. All rights reserved.",
        Anchor: "Anchor",
        Margins: "外邊距（Margins）",
        top: "top",
        right: "right",
        bottom: "bottom",
        left: "left",
        Classes: "Classes",
        Src: "Src",
        Title: "Title",
        Link: "Link",
        file: "file",
        "Image properties": "圖片屬性",
        "Your code is similar to HTML. Keep as HTML?":
          "你黏貼的文本是一段html代碼，是否保留源格式",
        "Paste as HTML": "html黏貼",
        "Insert as Text": "把html代碼視為普通文本",
        "Error on load list": "加載list錯誤",
        Break: "Pause",
        "No follow": "No follow",
        URL: "URL",
        Crop: "Crop",
        Default: "默認",
        Circle: "圓圈",
        Dot: "點",
        Quadrate: "方形",
        Find: "搜尋",
        "Insert className": "插入標籤名稱",
        "Press Alt for custom resizing": "按Alt自定義調整大小",
        "Find Next": "找下一個",
        "Find Previous": "找上一個",
        replace: "替代",
        "Line height": "行高",
      },
    },
    uploader: {
      insertImageAsBase64URI: true,
      imagesExtensions: ["jpg", "png", "jpeg", "gif", "svg", "webp"],
    },
  };

  const onContentChange = (content, name) => {
    setContent(content);
    if (propsForm) {
      propsForm.setFieldValue(name, content);
    } else {
      form.setFieldValue(name, content);
    }
  };

  useEffect(() => {
    if (!!propsValue) {
      setContent(propsValue[name]);
    }
  }, [propsValue]);
  return (
    <>
      <JoditEditor
        ref={editor}
        value={content}
        config={config}
        tabIndex={1} // tabIndex of textarea
        onBlur={(content) => onContentChange(content, name)} // preferred to use only this option to update the content for performance reasons
        height={1000}
        allowResizeX={true}
        allowResizeY={true}
      />
    </>
  );
};
